import moment from 'moment'
import {
  USER_SUBSCRIPTION_STATUS_DEMO,
  USER_SUBSCRIPTION_STATUS_NONE,
  USER_SUBSCRIPTION_STATUS_OVER
} from '@/config'

export default class UserSubscription {
  constructor (data) {
    this.status = data.type ?? USER_SUBSCRIPTION_STATUS_NONE
    this.expiresAt = data.expires ? moment(data.expires) : null
    this.durationDefault = data.trial_period ?? null
    this.daysLeft = data.expiration_days ?? 0
  }

  get isNone () {
    return this.status === USER_SUBSCRIPTION_STATUS_NONE
  }

  get isOver () {
    return this.status === USER_SUBSCRIPTION_STATUS_OVER || (this.expiresAt && this.daysLeft <= 0)
  }

  get isDemo () {
    return !this.isOver && this.status === USER_SUBSCRIPTION_STATUS_DEMO
  }

  get duration () {
    if (this.isNone || this.isOver || !this.expiresAt) return 0
    return this.daysLeft > 0 ? this.daysLeft : 0
  }

  get expires () {
    return this.expiresAt.format('DD.MM.YYYY') ?? null
  }
}
